module.exports = __webpack_public_path__ + "img/w3_mc_dark.7bc0a10d.png";